const reportWindowSize = () => {
    // permet d'appliquer une taille 100% du viewport pour les images et card XL
    //must be load the most early possible
    let containerClassique = document.querySelector('.content-side-left');
    document.documentElement.style.setProperty('--window-width', document.querySelector('body').offsetWidth + 'px');

    // sur toute les pages
    if (containerClassique !== null) {
        document.documentElement.style.setProperty('--window-marge-content', -containerClassique.getBoundingClientRect().left + 'px');
    }

    //dans les articles
    let containerArticle = document.querySelector('.post-template-default .entry-content');
    if (containerArticle !== null) {
        document.documentElement.style.setProperty('--window-article-marge-content', -containerArticle.getBoundingClientRect().left + 'px');
    }
}

export default reportWindowSize;

